export default __webpack_public_path__ + "static/media/mask.6a6b81b6.png";